/**
 * Risolve la lista di id filtro per una pagina dashboard.
 * Priorità: `reportConfiguration.filterSets[filterSetKey]` (JSON), altrimenti registry in codice.
 *
 * `filterSets` nel JSON può essere:
 * - array di stringhe: `["registered_at", "area_name"]`
 * - oggetto: `{ "filterRefs": ["registered_at", ...] }`
 */
export const resolvePageFiltersConfig = (reportConfiguration, filterSetKey, fallbackRegistry = {}) => {
    if (!filterSetKey) return [];
    const raw = reportConfiguration?.filterSets?.[filterSetKey];
    const list = Array.isArray(raw) ? raw : raw?.filterRefs;
    if (Array.isArray(list) && list.length > 0) {
        return list;
    }
    return fallbackRegistry[filterSetKey] || [];
};
